export const gtagSendEvent = (eventName, url) => {
    const callback = function () {
      if (typeof url === 'string') {
        window.location = url;
      }
    };
    
    window.gtag('event', eventName, {
      'send_to': 'AW-17813199906/p_lmCKrx7tQbEKK4_61C',
      'event_callback': callback,
      'event_timeout': 2000,
    });
  };



